import { TaskStatus } from '../domain/task/TaskStatus';

export const STOP_STATUS = {
  pending: `pending`,
  incomplete: `incomplete`,
  canceled: `canceled`,
  completed: `completed`,
};

export const STOP_TASK_STATUS = {
  pending: `pending` as TaskStatus,
  canceled: `canceled` as TaskStatus,
  completed: `completed` as TaskStatus,
};
